import React , { useEffect } from "react";
import TourDetails from "../pages/TourDetails";

// Hero Image
import shimlaHero from "../assets/shimla.png";

// Gallery Images
import g1 from "../assets/shimla.png";
import g2 from "../assets/ShimlaChd/kufri.png";
import g3 from "../assets/Narkanda/Narkanda.png";
import g4 from "../assets/ShimlaChd/jakhu.png";

export default function ShimlaChandigarhTour() {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <TourDetails
      title="Shimla – Chandigarh Tour"
      duration="03 Nights / 04 Days"
      includes="Shimla, Kufri, Narkanda, Jakhoo Temple, Chandigarh Drop"

      heroImage={shimlaHero}

      galleryImages={[g1, g2, g3, g4]}

      tourPlan={{
        inclusions: [
          "03 Nights Hotel Stay in Shimla – Deluxe Room",
          "Daily Breakfast & Dinner",
          "Private Cab for Complete Sightseeing",
          "Pickup & Drop – Chandigarh",
          "All Applicable Taxes Included"
        ],

        days: [
          {
            title: "Day 01: Chandigarh → Shimla (125 km / 8 hrs)",
            points: [
              "Arrive at Chandigarh on your own",
              "Drive to Shimla via Himalayan Foothills",
              "Check-in at the hotel",
              "Explore surroundings at leisure",
              "Overnight stay in Shimla"
            ],
          },

          {
            title: "Day 02: Shimla – Kufri Sightseeing",
            points: [
              "Breakfast at hotel",
              "Drive to Kufri – famous for snow & adventure activities",
              "Hike or take horse/mule to Mahasu Peak",
              "Return to Shimla",
              "Visit Jakhoo Temple (Lord Hanuman Temple)",
              "Evening free at Mall Road",
              "Overnight stay at hotel"
            ],
          },

          {
            title: "Day 03: Shimla → Narkanda",
            points: [
              "After breakfast, depart for Narkanda (65 km)",
              "Enjoy views of snow-capped Himalayan ranges",
              "Visit Hatu Peak & Hatu Mata Temple",
              "Explore Jor Bagh Campsite",
              "Drive back to Shimla",
              "Overnight stay at hotel"
            ],
          },

          {
            title: "Day 04: Shimla → Chandigarh (125 km / 8 hrs)",
            points: [
              "Breakfast at hotel",
              "Checkout and drive to Chandigarh",
              "Drop at Airport / Railway Station",
              "Tour Ends with Beautiful Memories"
            ],
          },
        ],
      }}

      exclusions={[
        "Any monument entry fees / camera fees",
        "Any meal not mentioned",
        "Any guide charges",
        "Air / Train fare",
        "Heater charges",
        "Porter / Coolie charges",
        "5% GST Extra"
      ]}

      remarks={[
        "Rates are subject to change without prior notice",
        "Accommodation provided at listed or similar hotels",
        "Confirmation subject to availability",
        "AC will not work in hill areas",
        "No refund for unused services due to weather or road blocks",
        "Base category rooms in all packages",
        "If Rohtang Pass is restricted by NGT, guests must bear separate expenses"
      ]}
    />
  );
}
